/** @module */

/**
 * @enum {string}
 * @includevals
 */
export const sceneViewTypes = {
    pano: 'pano',
    flat: 'flat',
};